import classNames from "classnames";
import { Calendar, ConfigProvider } from "antd";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
import { getFormattedLocale } from "@/features/calendar/model";
import { BaseMobileHeader } from "@/common";
import type { Dayjs } from "dayjs";
import { CalendarHeader } from "../calendar-header";
import { CalendarFooter } from "../calendar-footer";
import { useCalendarViewMobile } from "../hooks";
import { CellRenderMobile } from "../cell-render";
import { EventList } from "../event-list";
import styles from "./styles.module.scss";

export const CalendarViewMobile = () => {
  const { i18n, t } = useTranslation();
  const { selectedDate, onChange } = useCalendarViewMobile();

  return (
    <div className={styles.wrapper}>
      <BaseMobileHeader title={t("common.calendar")} />
      <ConfigProvider locale={getFormattedLocale(i18n.language)}>
        <Calendar
          value={dayjs(selectedDate)}
          className={classNames(styles.calendar, styles["calendar-ru"])}
          fullscreen={false}
          headerRender={({ value }) => <CalendarHeader value={value} />}
          fullCellRender={(value: Dayjs) => <CellRenderMobile date={value} />}
          onChange={onChange}
        />
        <CalendarFooter />
        <EventList />
      </ConfigProvider>
    </div>
  );
};
